module.exports = __webpack_public_path__ + "assets/img/img-detail.a9b17ccd.jpg";